import { render, staticRenderFns } from "./ResetForgottenPassword.vue?vue&type=template&id=b5ff0488&"
import script from "./ResetForgottenPassword.vue?vue&type=script&lang=js&"
export * from "./ResetForgottenPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports